import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { LoanDuesObj } from "../../utils/types";

const initialState: LoanDuesObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getLoanDuesData = createAsyncThunk(
  "loans/getLoanDues",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const loanDuesSlice = createSlice({
  name: "loan-dues",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoanDuesData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLoanDuesData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getLoanDuesData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default loanDuesSlice.reducer;
